import React, { ButtonHTMLAttributes } from "react";

interface ModuleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  text?: string;
  variant?: "wide" | "tall";
  className?: string;
}

function TopicButton({
  variant = "wide",
  icon,
  text,
  className,
  ...props
}: ModuleButtonProps) {
  const wideStyles = "w-full h-[88px] flex-row items-center";
  const tallStyles =
    "w-[112px] h-[125px] flex-col items-center justify-center text-sm p-0";

  const variantStyles = variant === "tall" ? tallStyles : wideStyles;

  return (
    <div className={className}>
      <button
        {...props}
        className={`p4l-button rounded-lg ${variantStyles} p-0`}
      >
        <span
          className={`${
            variant === "tall"
              ? "mb-1 w-full flex justify-center"
              : "mr-4 flex-none"
          }`}
        >
          {icon}
        </span>
        <span
          className={`${
            variant === "tall"
              ? "text-center font-normal line-clamp-2 w-full min-h-[2.5rem] whitespace-normal break-words hyphens-auto px-0.1 flex items-center justify-center"
              : "text-left"
          }`}
        >
          {text}
        </span>
      </button>
    </div>
  );
}

export default TopicButton;
